import { render, staticRenderFns } from "./VisitCard.vue?vue&type=template&id=052ec312&"
import script from "./VisitCard.vue?vue&type=script&lang=js&"
export * from "./VisitCard.vue?vue&type=script&lang=js&"
import style0 from "./VisitCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports